import React from "react";
import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";
import AppStoreBadge from "./AppStoreBadge";

function Footer() {
  return (
    <footer className="dynerz-footer">
      <Container fluid>
        <nav className="dynerz-footer-links" aria-label="Footer">
          <Link to="/about">About</Link>
          <span className="dynerz-footer-sep" aria-hidden="true">·</span>
          <Link to="/contact">Contact</Link>
          <span className="dynerz-footer-sep" aria-hidden="true">·</span>
          <Link to="/privacy">Privacy</Link>
          <span className="dynerz-footer-sep" aria-hidden="true">·</span>
          <Link to="/terms">Terms</Link>
          <span className="dynerz-footer-sep" aria-hidden="true">·</span>
          <Link to="/faq">FAQ</Link>
        </nav>
        <AppStoreBadge />
        <p className="dynerz-footer-copy">© 2026 intrnauts</p>
      </Container>
    </footer>
  );
}

export default Footer;
